<template>
	<div class="card-item__main">
		<div class="card-item__info">
			<div class="card-item__icon">
				<i :class="iconClass" />
			</div>
			<div class="card-item__number-name">
				<span class="card-item__number"> ({{ number }}) </span
				><slot name="ellipsis" />
			</div>
		</div>
		<div class="card-item__features">
			{{ features }}
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
export default {
	name: 'CompanyLocationFeatureCard',
	props: {
		number: {
			type: [String, Number],
			required: true
		},
		companyLocation: {
			type: Object,
			required: true
		},
		iconClass: {
			type: String,
			required: true
		}
	},
	computed: {
		features() {
			const { features } = this.companyLocation;

			if (!_.isEmpty(features)) {
				return features.map(feature => feature.description).join(', ');
			}
			return '';
		}
	}
};
</script>

<style lang="scss" scoped>
.card-item {
	&__main {
		display: flex;
		flex-direction: column;
	}
	&__info {
		display: flex;
		gap: $gutter-md;
	}

	&__icon {
		font-size: 18px;
	}
	&__number {
		font-size: $bd-txt-font-size-regular;
		font-weight: $medium-font-weight;
	}
	&__number-name {
		display: flex;
		gap: $gutter-xs;
		align-content: center;
		flex-wrap: wrap;
	}
	&__features {
		font-size: $bd-txt-font-size-regular;
		margin-left: $gutter-xl;
	}
}
</style>
